module.exports = __webpack_public_path__ + "img/num4.d87963b0.png";